const companyFinancialsWithExtraMarketing = (variables, months = 35) => {
  const companyFinancials = []
  for (let i = 0; i <= months; i++) {
    companyFinancials.push(
      getMonthCompanyFinancialsFejron(
        variables,
        i,
        i > 0 ? companyFinancials[i - 1] : 0
      )
    )
  }
  return companyFinancials
  // console.log('companyFinancials', companyFinancials)
}

const getMonthCompanyFinancialsFejron = (variables, month, prevMonth) => {
  const vars = variables
  let valuation, // A
    sales, // C
    gross_profit, // D
    direct_costs, // E
    total_expenses, // H
    marketing_sales_costs, // G
    opex, // F
    cashflow_from_operations, // I
    arr_end, //L
    potential_ccs, // M
    ccs_funding, // N
    ccs_available, // O
    ccs_available_procent, // P
    bank_balance, // X
    net_cash_flow, // Y
    company_runway, // Z
    new_css, // Q
    additional_css_fuel, // R
    interest_payment, //S
    additional_sm_spend, // U
    additional_mrr_from_sm, // V
    funding, // AD
    number_of_shares,
    price_per_share,
    new_shares,
    new_ownership,
    founder_ownership

  if (month === 0) {
    // row 4
    sales = vars.mrr // C
    valuation = sales * 12 * vars.saas_multiple // A
    gross_profit = sales * vars.gross_margin // D
    direct_costs = sales - gross_profit // E
    total_expenses = vars.monthly_expenses // H
    marketing_sales_costs = sales * vars.sales_marketing_costs_share // G
    opex = total_expenses - marketing_sales_costs - direct_costs // F
    cashflow_from_operations = sales - total_expenses // I
    arr_end = sales * 12 //L
    potential_ccs = arr_end * vars.share_of_arr_fejron // M
    ccs_funding = 0 // N
    ccs_available = potential_ccs - ccs_funding // O
    ccs_available_procent = ccs_available / potential_ccs // P
    bank_balance = vars.bank_account_at_start // X
    company_runway =
      bank_balance < 0
        ? 'Out of cash'
        : bank_balance < total_expenses - gross_profit
        ? 'Last month'
        : '' // Z
    new_css =
      ccs_available_procent < 0.01
        ? 0
        : bank_balance > total_expenses
        ? 0
        : Math.min(marketing_sales_costs, ccs_available) // Q

    additional_css_fuel = Math.min(
      marketing_sales_costs * vars.fejron_increased_spend_marketing,
      ccs_available - new_css
    ) // R
    interest_payment =
      (ccs_funding + new_css + additional_css_fuel) *
      vars.irr_equivalent_monthly_interest_rate
    //S
    additional_sm_spend = additional_css_fuel // U
    additional_mrr_from_sm =
      additional_css_fuel * vars.increased_MRR_per_unit_spent_SM // V
    net_cash_flow =
      gross_profit -
      total_expenses +
      new_css +
      additional_css_fuel -
      additional_sm_spend // Y
    funding =
      funding === 'Last month'
        ? total_expenses * gross_profit * vars.month_runway_runout
        : 0
    number_of_shares = vars.original_number_of_shares
    price_per_share = valuation / number_of_shares
    new_shares = funding / price_per_share
    new_ownership = funding / (valuation + funding)
    founder_ownership =
      vars.original_number_of_shares / (number_of_shares + new_shares)
  } else {
    // row 5+
    sales = prevMonth.sales * (1 + vars.mom) + prevMonth.additional_mrr_from_sm // C
    valuation = sales * 12 * vars.saas_multiple // A
    gross_profit = sales * vars.gross_margin // D
    direct_costs = sales - gross_profit // E
    total_expenses = prevMonth.total_expenses * (1 + vars.total_expenses) // H
    marketing_sales_costs = sales * vars.sales_marketing_costs_share // G
    opex = total_expenses - marketing_sales_costs - direct_costs // F
    cashflow_from_operations = sales - total_expenses // I
    arr_end = sales * 12 //L
    potential_ccs = arr_end * vars.share_of_arr_fejron // M
    ccs_funding =
      prevMonth.new_css +
      prevMonth.interest_payment +
      prevMonth.ccs_funding +
      prevMonth.additional_css_fuel // N
    ccs_available = potential_ccs - ccs_funding // O
    ccs_available_procent = ccs_available / potential_ccs // P
    bank_balance =
      prevMonth.bank_balance + prevMonth.net_cash_flow + prevMonth.funding // X

    company_runway =
      bank_balance < 0
        ? 'Out of cash'
        : bank_balance < total_expenses - gross_profit
        ? 'Last month'
        : '' // Z

    new_css =
      ccs_available_procent < 0.01 // Checked
        ? 0
        : bank_balance > total_expenses // Checked
        ? 0
        : Math.min(marketing_sales_costs, ccs_available) // Q
    additional_css_fuel = Math.min(
      marketing_sales_costs * vars.fejron_increased_spend_marketing,
      ccs_available - new_css
    ) // R
    interest_payment =
      (ccs_funding + new_css + additional_css_fuel) *
      vars.irr_equivalent_monthly_interest_rate
    //S
    additional_sm_spend = additional_css_fuel // U
    additional_mrr_from_sm =
      additional_css_fuel * vars.increased_MRR_per_unit_spent_SM // V
    net_cash_flow =
      gross_profit - // CHECKED
      total_expenses + // CHECKED
      new_css + // CHECKED
      additional_css_fuel - // CHECKED
      additional_sm_spend // Y
    funding =
      company_runway === 'Last month'
        ? (total_expenses - gross_profit) * vars.month_runway_runout
        : 0
    number_of_shares = prevMonth.number_of_shares + prevMonth.new_shares
    price_per_share = valuation / number_of_shares
    new_shares = funding / price_per_share
    new_ownership = funding / (valuation + funding)
    founder_ownership =
      vars.original_number_of_shares / (number_of_shares + new_shares)
  }
  return {
    valuation,
    month,
    sales,
    gross_profit,
    direct_costs,
    total_expenses,
    marketing_sales_costs,
    opex,
    cashflow_from_operations,
    arr_end,
    potential_ccs,
    ccs_funding,
    ccs_available,
    ccs_available_procent,
    bank_balance,
    company_runway,
    new_css,
    additional_css_fuel,
    interest_payment,
    additional_sm_spend,
    additional_mrr_from_sm,
    net_cash_flow,
    funding,
    number_of_shares,
    price_per_share,
    new_shares,
    new_ownership,
    founder_ownership
  }
}

export { companyFinancialsWithExtraMarketing }
